import { Component } from '@angular/core';

@Component({
    selector: 'unauthorized',
    imports: [],
    templateUrl: './unauthorized.component.html',
    styleUrl: './unauthorized.component.sass'
})
export class UnauthorizedComponent {}
